import styled from 'styled-components';
import type { TransactionProps } from '@/pages/CompanyReport/components/InsiderTradingTransactions/components/Transaction';
import { TransactionType } from '@/pages/CompanyReport/components/InsiderTradingTransactions/components/Transaction';
import DataTable from '@/components/DataTable';

export const InsiderTradingTable = styled(DataTable)`
  margin-bottom: ${({ theme }) => theme.x2spacePx}px;

  caption {
    text-align: left;
  }
`;

export const TransactionColumn = styled('td')`
  position: relative;
`;

export const TransactionTypePositioned = styled(
  TransactionType
)<TransactionProps>`
  position: absolute;
  left: ${({ theme }) => theme.x1spacePx}px;
`;

export const EntityColumn = styled('td')`
  > span {
    opacity: 0.5;
  }
`;
